import axios from "axios";
import { toastr } from "react-redux-toastr";
import Api, { cashierApi, rootUrl } from "../../utils/config/api";
import isEmpty from "../../utils/constants/isEmpty";
import setCashierToken from "../../utils/constants/setCashierToken";
import {
  SET_CURRENT_CASHIER,
  SET_CURRENT_CUSTOMER,
  SET_CURRENT_CASHIER_DATA,
  SET_CUSTOMER_REDEEMABLE_REWARDS,
  SET_POINTS_ON_FIRST_ORDER,
  SET_STORE_REWARDS,
  SET_REDEEMED_DATA,
  GET_ALL_STORE_ORDERS,
  NEXT_CUSTOMER_INITIALIZE,
  SET_CURRENT_CASHIER_CREDITS,
  SET_CASHIER_PARENT,
  SET_CASHIER_STORE_DETAILS,
} from "../types";

export const setCurrentCashier = (tokenObj) => (dispatch) => {
  setCashierToken(tokenObj?.token);
  dispatch({
    type: SET_CURRENT_CASHIER,
    payload: !isEmpty(tokenObj?.token),
  });
};

export const setCurrentCashierData = (cashier) => (dispatch) => {
  dispatch({
    type: SET_CURRENT_CASHIER_DATA,
    payload: cashier,
  });
};

export const setCurrentCustomerData = (customer) => (dispatch) => {
  dispatch({
    type: SET_CURRENT_CUSTOMER,
    payload: customer,
  });
};

export const initalizeAfterNextCustomer = () => (dispatch) => {
  dispatch({
    type: NEXT_CUSTOMER_INITIALIZE,
  });
};

export const getCashierToken = () => (dispatch) => {
  if (localStorage.cashierAccessToken) {
    const tokenObj = JSON.parse(localStorage.cashierAccessToken);
    const { token, expires } = tokenObj;

    if (new Date(`${expires}`) < Date.now()) {
      // accessToken expires
      dispatch(setCurrentCashier({}));
      localStorage.removeItem("cashierAccessToken");
    } else {
      //set cashier and isAuthenticated
      dispatch(setCurrentCashier(tokenObj));

      if (token) {
        cashierApi.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      }
    }
  }
};

export const cashierSignupCall = (data, store_id) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.post(`/v1/cashier/signup/${store_id}`, data)
      .then((res) => {
        if (res.data.success) {
          return dispatch(cashierLoginCall(data, store_id)).then(() =>
            resolve("Signup success")
          );
        } else {
          return reject(res.data?.message);
        }
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const cashierChangePasswordCall = (data, store_id) => () => {
  return new Promise((resolve, reject) => {
    Api.post(`/v1/cashier/change-password/${store_id}`, data)
      .then((res) => {
        return resolve(res.data?.payload);
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const cashierLoginCall = (data, store_id) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.post(`/v1/cashier/signin/${store_id}`, data)
      .then((res) => {
        const { tokens, user } = res.data.payload;
        dispatch(setCurrentCashier(tokens.access));
        dispatch(setCurrentCashierData(user));
        localStorage.setItem(
          "cashierAccessToken",
          JSON.stringify(tokens.access)
        );
        localStorage.setItem(
          "cashierRefreshToken",
          JSON.stringify(tokens.refresh)
        );

        return resolve("Login success");
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const createCustomerCall = (data, store_id) => (dispatch) => {
  return new Promise((resolve, reject) => {
    cashierApi
      .put(`/v1/cashier/customer/${store_id}`, data)
      .then((res) => {
        const { payload } = res.data;
        dispatch({
          type: SET_CURRENT_CUSTOMER,
          payload: payload,
        });
        return resolve(payload);
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          err?.response?.data?.errors?.map((errObj) =>
            toastr.error(errObj.msg)
          );
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const createOrderCall = (data, store_id) => (dispatch) => {
  return new Promise((resolve, reject) => {
    cashierApi
      .post(`/v1/cashier/customer/order/${store_id}`, data)
      .then((res) => {
        dispatch({
          type: SET_POINTS_ON_FIRST_ORDER,
          payload: res.data.payload?.order,
        });
        return resolve(res.data);
      })
      .catch((err) => {
        toastr.error(
          "Error",
          err?.response?.data?.message || "Something went wrong!"
        );
        return reject(err);
      });
  });
};

export const searchCustomersCall = (store_id, query) => () => {
  return new Promise((resolve, reject) => {
    cashierApi
      .get(`v1/cashier/${store_id}/customer?query=${query}`)
      .then((res) => {
        return resolve(res?.data?.payload);
      })
      .catch((err) => reject(err));
  });
};

export const findCustomerByNumberCall =
  (store_id, phoneNumber) => (dispatch) => {
    return new Promise((resolve, reject) => {
      cashierApi
        .get(`/v1/cashier/customer/${store_id}/${phoneNumber}`)
        .then((res) => {
          const { payload } = res.data;
          dispatch({
            type: SET_CURRENT_CUSTOMER,
            payload: payload,
          });

          return resolve("success");
        })
        .catch((err) => {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err);
        });
    });
  };

export const redeemPointsCall = (data, store_id, customer_id) => (dispatch) => {
  return new Promise((resolve, reject) => {
    cashierApi
      .post(
        `/v1/cashier/customer/points/redeem/${store_id}/${customer_id}`,
        data
      )
      .then((res) => {
        dispatch({
          type: SET_REDEEMED_DATA,
          payload: res?.data?.payload,
        });
        return resolve(res.data.payload);
      })
      .catch((err) => {
        toastr.error(
          "Error",
          err?.response?.data?.message || "Something went wrong!"
        );
        return reject(err);
      });
  });
};

export const getCustRewardsCall = (store_id, custId) => (dispatch) => {
  return new Promise((resolve, reject) => {
    cashierApi
      .get(`/v1/cashier/customer/rewards/${store_id}/${custId}`)
      .then((res) => {
        const { payload } = res.data;
        dispatch({
          type: SET_CUSTOMER_REDEEMABLE_REWARDS,
          payload: payload,
        });

        return resolve("success");
      })
      .catch((err) => {
        toastr.error(
          "Error",
          err?.response?.data?.message || "Something went wrong!"
        );
        return reject(err);
      });
  });
};

export const getAllRewardsOfStore = (storeId) => (dispatch) => {
  return new Promise((resolve, reject) => {
    cashierApi
      .get(`/v1/cashier/loyalty/${storeId}`)
      .then((res) => {
        const payload = res?.data?.payload;
        dispatch({
          type: SET_STORE_REWARDS,
          payload: payload,
        });

        return resolve("success");
      })
      .catch((err) => {
        toastr.error(
          "Error",
          err?.response?.data?.message || "Something went wrong!"
        );
        return reject(err);
      });
  });
};

export const verifyRewardOtpCall =
  (data, store_id, custId, rewardType) => (dispatch) => {
    return new Promise((resolve, reject) => {
      cashierApi
        .post(
          `/v1/cashier/customer/points/redeem/otp/${store_id}/${custId}`,
          data
        )
        .then((res) => {
          dispatch({
            type: SET_REDEEMED_DATA,
            payload: res?.data?.payload,
          });
          toastr.success(
            rewardType === "campaign"
              ? "Reward redeemed successfully."
              : "Redeemed Successfully"
          );
          return resolve("success");
        })
        .catch((err) => {
          toastr.error(
            "Error",
            err?.response?.data?.message ||
              err?.response?.data?.response?.message ||
              "Something went wrong!"
          );

          return reject(err);
        });
    });
  };

export const handleAutoLoginAction = (store_id) => (dispatch) => {
  new Promise((resolve, reject) => {
    Api.post(`/v1/cashier/login_as_owner/${store_id}`)
      .then((res) => {
        const { tokens, user } = res.data.payload;
        dispatch(setCurrentCashier(tokens.access));
        dispatch(setCurrentCashierData(user));
        localStorage.setItem(
          "cashierAccessToken",
          JSON.stringify(tokens.access)
        );
        localStorage.setItem(
          "cashierRefreshToken",
          JSON.stringify(tokens.refresh)
        );
        localStorage.setItem("storeId", store_id);
        return resolve("Login success");
      })
      .then(() => {
        if (localStorage.storeId && localStorage.cashierAccessToken) {
          let a = document.createElement("a");
          document.body.appendChild(a);
          a.style = "display: none";
          a.href = `${window.location.origin}/cashier/${store_id}`;
          a.target = "_blank";
          a.rel = "noopener noreferrer";
          a.click();
          document?.body?.removeChild(a);
        }
      })
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );
        return reject(err);
      });
  });
};

export const logoutCashierCall = () => (dispatch) => {
  dispatch(setCurrentCashier({}));
  dispatch({
    type: SET_CASHIER_PARENT,
    payload: {},
  });
  localStorage.removeItem("cashierAccessToken");
  localStorage.removeItem("cashierRefreshToken");
};

export const refreshCashierAuthCall = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    // don't use axios cashierAPI instance here
    axios
      .post(`${rootUrl.baseUrl}/v1/cashier/refresh-tokens`, data)
      .then((res) => {
        const tokens = res.data.payload;
        dispatch(setCurrentCashier(tokens.access));
        localStorage.setItem(
          "cashierAccessToken",
          JSON.stringify(tokens.access)
        );
        localStorage.setItem(
          "cashierRefreshToken",
          JSON.stringify(tokens.refresh)
        );

        return resolve(tokens?.access?.token);
      })
      .catch((err) => {
        // toastr.error(
        //   "Error",
        //   err?.response?.data?.message || "Please Login again"
        // );
        dispatch(logoutCashierCall());
        return reject(err);
      });
  });
};

export const getStoreOrdersHistory =
  (storeId, period, page, customerId, action) => (dispatch) => {
    return new Promise((resolve, reject) => {
      cashierApi
        .get(
          `/v1/cashier/${storeId}/history?period=${period}${
            (page && `&page=${page}`) || ""
          }${(customerId && `&customer_id=${customerId}`) || ""}${
            (action && `&filter=${action}`) || ""
          }`
        )
        .then((res) => {
          dispatch({
            type: GET_ALL_STORE_ORDERS,
            payload: res?.data?.payload,
          });
          return resolve("success");
        })
        .catch((err) => {
          return reject(err);
        });
    });
  };

export const getCustomerSearchResultsForCashierStoreHistory = (
  storeId,
  page,
  limit,
  search
) => {
  const url = `/v1/cashier/${storeId}/find-customer?page=${page}&limit=${limit}&search=${search}`;

  return new Promise((resolve, reject) => {
    cashierApi
      .get(url)
      .then((res) => resolve(res?.data?.payload))
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );
        return reject(err);
      });
  });
};

export const getAvailableCashierCredits = (storeId) => (dispatch) => {
  return new Promise((resolve, reject) => {
    cashierApi
      .get(`/v1/cashier/credits/${storeId}`)
      .then((res) => {
        dispatch({
          type: SET_CURRENT_CASHIER_CREDITS,
          payload: res?.data?.payload,
        });
        return resolve(res?.data?.payload?.credits);
      })
      .catch((err) => {
        toastr.error("Failed to Get Credits Details");
        return reject(err);
      });
  });
};

export const getInitialLoginStatus = (storeId) => (dispatch) => {
  return new Promise((resolve, reject) => {
    cashierApi
      .get(`/v1/cashier/${storeId}/initial_login_status`)
      .then((res) => {
        dispatch({
          type: SET_CASHIER_PARENT,
          payload: res?.data?.payload?.user_details,
        });
        dispatch({
          type: SET_CASHIER_STORE_DETAILS,
          payload: res?.data?.payload?.store_details,
        });
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};
export const updateInitialLoginStatus = (storeId, data) => () => {
  return new Promise((resolve, reject) => {
    cashierApi
      .post(`/v1/cashier/${storeId}/initial_login_status`, data)
      .then((res) => {
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};

export const searchExistingTagsC = (storeId, search) => () => {
  return new Promise((resolve, reject) => {
    cashierApi
      .get(`/v1/cashier/customer/tags/${storeId}?query=${search}`)
      .then((res) => {
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};

export const createNewTagC = (data) => () => {
  return new Promise((resolve, reject) => {
    cashierApi
      .put(`/v1/cashier/customer/tag/create-tag`, data)
      .then((res) => {
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};

export const addOrUpdateCustomerTagsC = (data) => () => {
  return new Promise((resolve, reject) => {
    cashierApi
      .put(`/v1/cashier/customer/tag/add-tag`, data)
      .then((res) => {
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};

export const deleteCustomerTagsC = (data) => () => {
  return new Promise((resolve, reject) => {
    cashierApi
      .delete(`/v1/cashier/customer/delete-tag`, { data })
      .then((res) => {
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};
